import React, {useEffect} from 'react';
import CustomButton from '../CustomButton/CustomButton';
import Icon from '../../../utils/Icon';
import {Else, If, Then} from 'react-if';
import {formatPrice, isZero} from '../../../utils/helper';
import classnames from 'classnames';
import styles from './Card.module.scss';
import {isNotBlankOrNullString} from "../../../utils/stringUtils";
import greenPlus from "../../../assets/images/icons/greenPlus.png";
import mapping from "../../../config/mapping";

const Card = ({
                  rateplan,
                  noMarginTop = false,
                  onLearnMore = () => {
                  },
                  tabText = '',
                  freeText = '',
                  buttonText = '',
                  priceLabelText = '',
                  footerText = '',
                  subsidyAmount = '',
                  priceDiscountLabelText = '',
              }) => {

    useEffect(() => {
        const compareEvent = new CustomEvent("pageType", {
            detail: { pageType: 'rateplan' },
        });

        window.dispatchEvent(compareEvent);

    }, []);


    if (rateplan == null) return <></>;

    const {
        subName,
        displayName,
        mainName,
        characteristics,
        extraCharacteristics,
        initialPrice,
        finalPrice,
        imageUrl,
        associatedProducts,
        textOnProductDetails
    } = rateplan;

    const characteristicsMap = mapping.characteristicsMap;

    const handleLearnMoreClick = () => {
        onLearnMore(rateplan?.productUrl);
    };


    const RatePlanTitle = () => (
        <div className={classnames(styles.rate_plan_title_container)}>
            {isNotBlankOrNullString(subName) && isNotBlankOrNullString(displayName)
                ?
                <>
                    <div className={styles.rate_plan_title}>{subName}</div>
                    <div className={styles.rate_plan_sub_title}>{mainName}</div>
                </>
                :
                <div className={styles.rate_plan_sub_title}>{displayName}</div>
            }
        </div>
    );

    const RatePlanPrice = ({finalPrice, priceLabelText}) => (
        <div className={classnames(styles.main_price_container)}>
            <div className={styles.price_container}>
                <div className={styles.price_label}>{priceLabelText}</div>
                {initialPrice && initialPrice !== finalPrice &&
                    <div className={styles.initial_price}>{formatPrice(initialPrice)}</div>
                }

                <div className={styles.final_price}  style={(isZero(initialPrice) || initialPrice !== finalPrice) ? { color: '#E20074' } : {}}>
                    <If condition={isZero(finalPrice)}>
                        <Then>{freeText}</Then>
                        <Else>{formatPrice(finalPrice)}</Else>
                    </If>
                </div>
            </div>
        </div>
    );

    const sortCharacteristics = (characteristics) => {
        if (characteristics != null && characteristics?.length > 0) {
            const getCategory = char => {
                const key = char?.imgType.toLowerCase();
                if (key.includes("data")) return "data";
                if (key.includes("tonational")) return "minutes";
                if (key.includes("fixed")) return "minutes";
                if (key.includes("mobile")) return "minutes";
                if (key.includes("sms")) return "sms";

                return "other";
            };

            const order = ["data", "minutes", "sms", "other"];

            return [...characteristics].sort((a, b) => {
                return order.indexOf(getCategory(a)) - order.indexOf(getCategory(b));
            });
        }
    }

    const RatePlanCharacteristics = () => (
        <ul className={classnames(styles.characteristics_container, 'list-group mx-auto d-flex')}>
            {sortCharacteristics(characteristics)?.map((char, index) => (
                <div
                    className={classnames(styles.characteristic, Object.keys(characteristicsMap).includes(char?.imgType)
                        ? 'list-group-item d-flex' : '', textOnProductDetails ? styles.characteristic_label_container : '')}
                    key={index}>
                    {characteristicsMap[char?.imgType] &&
                        <div className="d-inline-flex align-items-center justify-content-center text-white rounded-circle m-0 me-2">
                            <Icon name={characteristicsMap[char?.imgType]} className={styles.characteristic_prefix_img}
                                  alt="device-lan"/>
                        </div>
                    }

                    {!(char.name === 'Contract Duration') &&
                        <>
                            <div className={styles.characteristic_text_container}>
                                {textOnProductDetails && index === 1 &&
                                    <div className={styles.characteristic_label}>
                                        <span>{textOnProductDetails}</span>
                                    </div>}
                                <div className={styles.characteristic_value}>
                                    {char?.prefix != null && (
                                        <span className={styles.characteristic_label_prefix}>{char?.prefix}</span>
                                    )}
                                    {char?.prefix != null && (char?.value != null || char?.unitOfMeasure != null) ? ' ' : ''}
                                    {(char?.value != null || char?.unitOfMeasure != null) && (
                                        <span className={styles.characteristic_label_value}>{char?.value}{char?.value != null && char?.unitOfMeasure != null ? ' ' : ''}{char?.unitOfMeasure}</span>
                                    )}
                                    {(char?.value != null || char?.unitOfMeasure != null) && char?.name != null ? ' ' : ''}
                                    {(char?.name != null) && (
                                        <span className={styles.characteristic_label_name} dangerouslySetInnerHTML={{ __html: char?.name }}></span>
                                    )}
                                </div>
                            </div>
                        </>
                    }
                </div>
            ))}
        </ul>
    );



    return (
        <div className={classnames(styles.plan_container, 'card border-0 h-100')}>
            {/* Conditional Top Tag */}
            {tabText &&
                <div className={styles.top_tag_container}>
                    <span className={styles.top_tag_text} dangerouslySetInnerHTML={{ __html: tabText }}/>
                </div>
            }
            <div className="card-body pt-0 px-0 d-flex gap-1 flex-column justify-content-between">
                {/* Top Section */}
                <div className={classnames(styles.card_top_section)}>
                    <RatePlanTitle/>
                    <RatePlanCharacteristics characteristics={characteristics}/>
                    <div className={styles.extraCharacteristics}
                         dangerouslySetInnerHTML={{__html: extraCharacteristics}}></div>

                </div>

                {/* Bottom Section */}
                <div className={classnames(styles.card_bottom_section)}>
                    {finalPrice
                        ? <>
                            <RatePlanPrice finalPrice={finalPrice} initialPrice={initialPrice}
                                           priceLabelText={priceLabelText}/>
                            <div className="w-100 px-3">
                                <CustomButton className={classnames(styles.item_button)}  onClick={() => window.location.href = `${window.location.origin}${rateplan?.productUrl}`}>
                                    {buttonText}
                                </CustomButton>
                            </div>
                        </>
                        : <div className={styles.footerText}>{footerText}</div>
                    }
                </div>
            </div>

        </div>
    );
};

export default Card;
